import type { RestorationPlan } from "../../types/dental";

interface ImplantToolboxProps {
  plan: RestorationPlan;
  onUpdatePlan: (planId: string, updates: Partial<RestorationPlan>) => void;
}

export function ImplantToolbox({ plan, onUpdatePlan }: ImplantToolboxProps) {
  return (
    <section className="procedure-toolbox-card card">
      <h3>Implant Toolbox</h3>

      <div className="field-stack">
        <div className="field-row">
          <label>Implant Catalog Item</label>
          <input
            type="text"
            value={plan.selectedCatalogItem || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, {
                selectedCatalogItem: e.target.value,
              })
            }
          />
        </div>

        <div className="field-row">
          <label>Material</label>
          <select
            value={plan.material || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { material: e.target.value })
            }
          >
            <option value="">Select material</option>
            <option value="Titanium">Titanium</option>
            <option value="Titanium Base + Crown">Titanium Base + Crown</option>
            <option value="Zirconia Abutment">Zirconia Abutment</option>
          </select>
        </div>

        <div className="field-row">
          <label>Shade</label>
          <input
            type="text"
            value={plan.shade || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { shade: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Spacing Notes</label>
          <textarea
            value={plan.spacingNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { spacingNotes: e.target.value })
            }
          />
        </div>

        <div className="field-row">
          <label>Production Notes</label>
          <textarea
            value={plan.productionNotes || ""}
            onChange={(e) =>
              onUpdatePlan(plan.planId, { productionNotes: e.target.value })
            }
          />
        </div>
      </div>
    </section>
  );
}